var $export = require('./_export');

$export($export.S + $export.F, 'Object', { classof: require('./_classof') });



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/core.object.classof.js
// module id = 626
// module chunks = 22